// Import directly from modular directory to avoid circular dependency
import BrowseCategoryPage from './browse-category/BrowseCategoryPage';

export {
  getServerSideProps,
} from "./browse-category-main";

export default BrowseCategoryPage;
